import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchCurrentUserInfo } from "../api.js";
import SuperadminDashboard from "./SuperadminDashboard.jsx";

export default function AdminRedirectPage() {
  const [loading, setLoading] = useState(true);
  const [redirectSlug, setRedirectSlug] = useState(null);
  const [showSuperadmin, setShowSuperadmin] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const info = await fetchCurrentUserInfo();
        if (!mounted) return;
        if (info.role === "superadmin") {
          setShowSuperadmin(true);
        } else if (info.role === "admin" && info.org_slug) {
          setRedirectSlug(info.org_slug);
        } else if (info.role === "admin") {
          setError("Contacte o suporte.");
        } else {
          setError("Sem acesso.");
        }
      } catch (err) {
        setError(err.response?.data?.detail || "Erro ao carregar informacao");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <main className="min-h-screen bg-background p-6 md:p-12">
        <p className="text-white text-center">A carregar...</p>
      </main>
    );
  }

  if (showSuperadmin) {
    return <SuperadminDashboard />;
  }

  if (redirectSlug) {
    return <Navigate to={`/admin/${redirectSlug}`} replace />;
  }

  return (
    <main className="min-h-screen bg-background p-6 md:p-12">
      <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-lg max-w-2xl mx-auto">
        {error || "Contacte o suporte."}
      </div>
    </main>
  );
}
